import { AwardingClient } from "@/utils/EvoClient";
import { InviteAllAdmittedParticipantsDto } from "../dto";
import { AxiosResponse } from "axios";

const ENDPOINT = "c/invite-all-admitted-participants";

export default async function inviteAllAdmittedParticipants(
  dto: InviteAllAdmittedParticipantsDto
): Promise<string> {
  return ((await AwardingClient.post(ENDPOINT, dto)) as AxiosResponse).data.id;
}
